// src/services/firebase.js
// ─────────────────────────────────────────────────────────────
//  Firebase 초기화 및 공통 인스턴스 export
//  .env.local 에 아래 변수를 설정하세요:
//    REACT_APP_FIREBASE_API_KEY
//    REACT_APP_FIREBASE_AUTH_DOMAIN
//    REACT_APP_FIREBASE_PROJECT_ID
//    REACT_APP_FIREBASE_STORAGE_BUCKET
//    REACT_APP_FIREBASE_MESSAGING_SENDER_ID
//    REACT_APP_FIREBASE_APP_ID
// ─────────────────────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const app  = initializeApp(firebaseConfig);

export const db      = getFirestore(app);
export const auth    = getAuth(app);
export const storage = getStorage(app);
export default app;
